import {reactive, computed, watch} from 'vue';

export default function Shift(data = {}) {
    const state = reactive({
        id: data.id || '',
        startsAt: data.startsAt || null,
        endsAt: data.endsAt || null,
        durationHours: data.durationHours !== undefined ? data.durationHours : null,
        guaranteedEarnings: data.guaranteedEarnings !== undefined ? data.guaranteedEarnings : null,
        maxDrivers: data.maxDrivers !== undefined ? data.maxDrivers : null,
        status: data.status || 'DRAFT',
        serviceJurisdictionId: data.serviceJurisdictionId || null,
        geoZoneId: data.geoZoneId || null,
        createdOn: data.createdOn || null,
        modifiedOn: data.modifiedOn || null
    });

    const validations = {
        isTimeRangeValid: computed(() => {
            if (!state.startsAt || !state.endsAt) return false;
            return new Date(state.endsAt) > new Date(state.startsAt);
        }),
        // A cleared <input type="number"> yields '' (Vue's number-casting leaves an unparseable
        // empty string as-is, not null) — durationHours is optional, so '' must count as unset,
        // same as null, or an admin could never clear it once set (#73 pre-commit review fix).
        isDurationHoursValid: computed(() => {
            const value = state.durationHours;
            return value === null || value === '' || value === undefined || value > 0;
        }),
        isGuaranteedEarningsValid: computed(() => state.guaranteedEarnings !== null && state.guaranteedEarnings > 0),
        isMaxDriversValid: computed(() => state.maxDrivers !== null && state.maxDrivers > 0)
    };

    const validateTimeRange = () => {
        if (validations.isTimeRangeValid.value) {
            $('#endsAt').removeClass('is-invalid');
            $('#endsAt-error').addClass('d-none');
            return true;
        } else {
            $('#endsAt').addClass('is-invalid');
            $('#endsAt-error').removeClass('d-none');
            return false;
        }
    };

    const validateDurationHours = () => {
        if (validations.isDurationHoursValid.value) {
            $('#durationHours').removeClass('is-invalid');
            $('#durationHours-error').addClass('d-none');
            return true;
        } else {
            $('#durationHours').addClass('is-invalid');
            $('#durationHours-error').removeClass('d-none');
            return false;
        }
    };

    const validateGuaranteedEarnings = () => {
        if (validations.isGuaranteedEarningsValid.value) {
            $('#guaranteedEarnings').removeClass('is-invalid');
            $('#guaranteedEarnings-error').addClass('d-none');
            return true;
        } else {
            $('#guaranteedEarnings').addClass('is-invalid');
            $('#guaranteedEarnings-error').removeClass('d-none');
            return false;
        }
    };

    const validateMaxDrivers = () => {
        if (validations.isMaxDriversValid.value) {
            $('#maxDrivers').removeClass('is-invalid');
            $('#maxDrivers-error').addClass('d-none');
            return true;
        } else {
            $('#maxDrivers').addClass('is-invalid');
            $('#maxDrivers-error').removeClass('d-none');
            return false;
        }
    };

    watch(() => state.startsAt, validateTimeRange);
    watch(() => state.endsAt, validateTimeRange);
    watch(() => state.durationHours, validateDurationHours);
    watch(() => state.guaranteedEarnings, validateGuaranteedEarnings);
    watch(() => state.maxDrivers, validateMaxDrivers);

    const isValid = () => {
        let isTimeRangeValid = validateTimeRange();
        let isDurationHoursValid = validateDurationHours();
        let isGuaranteedEarningsValid = validateGuaranteedEarnings();
        let isMaxDriversValid = validateMaxDrivers();
        return isTimeRangeValid && isDurationHoursValid && isGuaranteedEarningsValid && isMaxDriversValid;
    };

    const initializeValidation = () => {
        if (state.startsAt && state.endsAt) validateTimeRange();
        if (state.durationHours !== null) validateDurationHours();
        if (state.guaranteedEarnings !== null) validateGuaranteedEarnings();
        if (state.maxDrivers !== null) validateMaxDrivers();
    };

    setTimeout(initializeValidation, 100);

    return {
        state,
        validations,
        isValid,
        initializeValidation
    };
}
